import { Tooltip } from "@material-ui/core";
import React from "react";
import "./BB8AuthPanel.scss";
import BB8Button from "./BB8Button";
export interface IUser {
  sub: string;
  iss: string;
  username: string;
  email: string;
  role: "admin" | "basic";
  exp: number;
}

const BB8AuthPanel = ({
  user,
  logout
}: {
  user: IUser;
  logout: () => void;
}) => {
  if (user) {
    return (
      <section className="user-profile">
        <Tooltip
          title={
            <>
              <p>
                <small>email: </small>
                {user.email}
              </p>
              <p>
                <small>role: </small>
                {user.role}
              </p>
              <p>
                <small>sub: </small>
                {user.sub}
              </p>
            </>
          }
        >
          <div className="user">
            <img
              className="avatar"
              alt="avatar"
              src={require("../assets/images/bb8-person_outline-24px.svg")}
            />
            <span className="user-name">{user.username}</span>
          </div>
        </Tooltip>
        <div className="actions">
          <BB8Button
            id="bb8-btn-auth-signout"
            color="primary"
            size="small"
            onClick={logout}
          >
            Signout
          </BB8Button>
        </div>
      </section>
    );
  } else {
    return (
      <section className="user-profile">
        <div className="actions">
          <BB8Button id="bb8-btn-auth-signin" color="primary" size="small">
            Signin
          </BB8Button>
        </div>
      </section>
    );
  }
};

export default BB8AuthPanel;
